export interface ApplyPromoCodeResponse {
  success: boolean;
  message?: string;
  promoCodeId?: string;
  code?: string;
  discountDescription?: string;
  percentOff?: number | null;
  amountOff?: number | null;
  duration?: string;
  durationInMonths?: number | null;
}

export type PromoPlatform = 'stripe' | 'apple' | 'google';

/**
 * Apply a promotional code
 *
 * Platform-agnostic API call for validating and applying promo codes.
 * Currently supports Stripe, with Apple and Google Play coming soon.
 */
export const applyPromoCode = async (
  accessAuth0Token: string,
  promoCode: string,
  platform: PromoPlatform = 'stripe',
  productId?: string,
): Promise<ApplyPromoCodeResponse> => {
  const url = `${process.env.REACT_APP_BACKEND_URL}/payments/apply-promo-code`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessAuth0Token}`,
      },
      body: JSON.stringify({
        promoCode,
        platform,
        productId,
      }),
      credentials: "include",
    });

    const data = (await response.json()) as ApplyPromoCodeResponse;

    if (!response.ok) {
      return {
        success: false,
        message: data?.message || 'Failed to apply promo code',
      };
    }

    return data;
  } catch (error) {
    console.error('applyPromoCode error:', error);
    return { success: false, message: 'Network error' };
  }
};

